module.exports = __webpack_public_path__ + "img/barley@2x.png";